module.exports = __webpack_public_path__ + "bced6fb204a4462bd728e12a1b95e936.jpg";